/**
 * Alpha2 codes of countries currently participating in the Single Euro Payments Area (SEPA).
 *
 * Used by the SEPA bank country dropdown to filter the global GetCountryCodes result down to
 * the rails actually accepted for SEPA bank accounts when no country has been selected upstream
 * via SelectPaymentMethodV2.
 *
 * Source: European Payments Council list of SEPA participants. Update if the EPC scheme changes.
 */
export const SEPA_COUNTRY_ALPHA2_CODES: ReadonlySet<string> = new Set<string>([
  "AT", // Austria
  "BE", // Belgium
  "BG", // Bulgaria
  "HR", // Croatia
  "CY", // Cyprus
  "CZ", // Czechia
  "DK", // Denmark
  "EE", // Estonia
  "FI", // Finland
  "FR", // France
  "DE", // Germany
  "GR", // Greece
  "HU", // Hungary
  "IS", // Iceland
  "IE", // Ireland
  "IT", // Italy
  "LV", // Latvia
  "LI", // Liechtenstein
  "LT", // Lithuania
  "LU", // Luxembourg
  "MT", // Malta
  "MC", // Monaco
  "NL", // Netherlands
  "NO", // Norway
  "PL", // Poland
  "PT", // Portugal
  "RO", // Romania
  "SM", // San Marino
  "SK", // Slovakia
  "SI", // Slovenia
  "ES", // Spain
  "SE", // Sweden
  "CH", // Switzerland
  "VA", // Vatican City
  "AD", // Andorra
  "GB", // United Kingdom (post-Brexit, still SEPA participant)
  "AL", // Albania
  "MD", // Moldova
  "ME", // Montenegro
  "MK", // North Macedonia
  "RS", // Serbia
]);

export const isSepaCountry = (alpha2code?: string | null): boolean =>
  !!alpha2code && SEPA_COUNTRY_ALPHA2_CODES.has(alpha2code);
